import regExp from './reg-exp';

export enum PostMessageActions {
  HIDE_POPUP = 'HIDE_POPUP',
  OPEN_PUBLIC_POST = 'OPEN_PUBLIC_POST',
  OPEN_REVIEW = 'OPEN_REVIEW',
  OPEN_POPUP = 'OPEN_POPUP',
  THEME_LOADED = 'THEME_LOADED',
  THEME_FAILED = 'THEME_FAILED',
  POPUP_LOADED = 'POPUP_LOADED',
  LOAD_OLD_THEME = 'LOAD_OLD_THEME',
  PUBLIC_POST_SUBMITTED = 'PUBLIC_POST_SUBMITTED',
  REVIEW_SUBMITTED = 'REVIEW_SUBMITTED',
  CLOSE_POPUP = 'CLOSE_POPUP',
  EDITOR_PERSONALIZATION_CHANGED = 'EDITOR_PERSONALIZATION_CHANGED',
  EDITOR_OPENED_PUBLIC_POST = 'EDITOR_OPENED_PUBLIC_POST',
  EDITOR_OPENED_RATING_REVIEWS_POPUP = 'EDITOR_OPENED_RATING_REVIEWS_POPUP',
  EDITOR_OPENED_POPUP = 'EDITOR_OPENED_POPUP',
  EDITOR_CLOSED_POPUP = 'EDITOR_CLOSED_POPUP',
  UPDATE_POPUP_DATA = 'UPDATE_POPUP_DATA',
  CHANGE_POST_POPUP = 'CHANGE_POST_POPUP',
  EXPAND_POST_MESSAGE = 'EXPAND_POST_MESSAGE',
  SCROLL_TO_TOP_MESSAGE = 'SCROLL_TO_TOP_MESSAGE',
  INFINITE_SCROLL_FETCH = 'INFINITE_SCROLL_FETCH',
  POSTS_ARE_FETCHED = 'POSTS_ARE_FETCHED',
  RECORD_EMBED_LOCATION = 'RECORD_EMBED_LOCATION',
  RECORD_EMBED_VIEWED = 'RECORD_EMBED_VIEWED',
  PERSONALIZATION_FULLY_FETCHED = 'PERSONALIZATION_FULLY_FETCHED',
  TINT_ANALYTICS_LOADED = 'TINT_ANALYTICS_LOADED',
  TINT_ANALYTICS_QUERY = 'TINT_ANALYTICS_QUERY',
  GENERATE_SCHEMA = 'GENERATE_SCHEMA',
  UPDATE_SCHEMA = 'UPDATE_SCHEMA',
}

enum HighlightVideoPlaybackOptions {
  DONT_PLAY = 'dont-autoplay',
  PLAY_ENTIRE = 'play-entire-video',
  PLAY_TO_TRANSITION = 'play-to-transition',
}

export enum ThemeLayoutOptions {
  TEXT = 'text',
  IMAGE = 'image',
  TEXT_ON_HOVER = 'text_on_hover',
  VIDEO = 'video',
}

export const globalConfig = {
  urls: {
    tiktokSDKUrl: 'https://www.tiktok.com/embed.js',
    blankAvatarUrl: 'https://cdn.hypemarks.com/assets/analytics/EmptyProfile.png',
  },
  shareWindow: {
    width: 500,
    height: 300,
  },
  highlightPosts: {
    dontPlay: HighlightVideoPlaybackOptions.DONT_PLAY,
    playEntire: HighlightVideoPlaybackOptions.PLAY_ENTIRE,
    playToTransition: HighlightVideoPlaybackOptions.PLAY_TO_TRANSITION,
  },
  postMessage: {
    actions: {
      hidePopup: PostMessageActions.HIDE_POPUP,
      openPublicPost: PostMessageActions.OPEN_PUBLIC_POST,
      openReview: PostMessageActions.OPEN_REVIEW,
      openPopup: PostMessageActions.OPEN_POPUP,
      themeLoaded: PostMessageActions.THEME_LOADED,
      themeFailed: PostMessageActions.THEME_FAILED,
      popupLoaded: PostMessageActions.POPUP_LOADED,
      loadOldTheme: PostMessageActions.LOAD_OLD_THEME,
      publicPostSubmitted: PostMessageActions.PUBLIC_POST_SUBMITTED,
      reviewSubmitted: PostMessageActions.REVIEW_SUBMITTED,
      closePopup: PostMessageActions.CLOSE_POPUP,
      editorPersonalizationChanged: PostMessageActions.EDITOR_PERSONALIZATION_CHANGED,
      editorOpenedPublicPost: PostMessageActions.EDITOR_OPENED_PUBLIC_POST,
      editorOpenedPopup: PostMessageActions.EDITOR_OPENED_POPUP,
      editorClosedPopup: PostMessageActions.EDITOR_CLOSED_POPUP,
      updatePopupData: PostMessageActions.UPDATE_POPUP_DATA,
      changePostPopup: PostMessageActions.CHANGE_POST_POPUP,
      expandPostMessage: PostMessageActions.EXPAND_POST_MESSAGE,
      fetchInfiniteScroll: PostMessageActions.INFINITE_SCROLL_FETCH,
      scrollToTopMessage: PostMessageActions.SCROLL_TO_TOP_MESSAGE,
      postsAreFetched: PostMessageActions.POSTS_ARE_FETCHED,
      recordEmbedLocation: PostMessageActions.RECORD_EMBED_LOCATION,
      recordEmbedViewed: PostMessageActions.RECORD_EMBED_VIEWED,
      personalizationFullyFetched: PostMessageActions.PERSONALIZATION_FULLY_FETCHED,
      popupPostChange: PostMessageActions.CHANGE_POST_POPUP, // duplicate?
      expandContainer: PostMessageActions.EXPAND_POST_MESSAGE, // duplicate?
      tintAnalyticsScriptLoaded: PostMessageActions.TINT_ANALYTICS_LOADED,
      tintAnalyticsQuery: PostMessageActions.TINT_ANALYTICS_QUERY,
      generateSchema: PostMessageActions.GENERATE_SCHEMA,
      updateSchema: PostMessageActions.UPDATE_SCHEMA,
    },
  },
  regExp: regExp,
  icons: {
    common: {
      share: {
        color: '#ccc',
        fontSize: '16px',
      },
      postAction: {
        fontSize: '12px',
      },
      sourceIconAsImage: {
        fontSize: '30px',
      },
    },
    popup: {
      navigation: {
        fontSize: '30px',
      },
      sourceIconAsImage: {
        fontSize: '30px',
      },
    },
    themes: {
      navItem: {
        color: '#fff',
      },
      navSearch: {
        color: '#fff',
      },
    },
  },
  masonry: {
    transitionSpeed: 100,
  },
  tooltip: {
    hideSpeed: 500,
    hideUpdate: 500,
  },
  fileStack: {
    width: {
      default: 300,
      xSmallMediaQuery: 400,
      smallMediaQuery: 500,
      mediumMediaQuery: 500,
    },
  },
  defaultShareOptions: ['fb', 'li', 'pin', 'email', 'tw'],
  defaultPublicPostPlaceholders: {
    authorImageLabel: 'Upload a photo of yourself:',
    customLabel: 'Custom Field',
    customPlaceholder: 'Additional information...',
    descriptionPlaceholder: 'Write a caption...',
    emailLabel: 'Your Email',
    emailPlaceholder: 'example@example.com',
    globalErrorText: 'Check your form for errors.',
    nameLabel: 'Your Name',
    namePlaceholder: 'First & Last Name',
    postImagePlaceholder: 'Upload Files',
    requiredText: '*Required',
    submitButton: 'share my post now!',
    termsLinkText: 'Terms & Conditions!',
    termsText: 'By submitting my photo and additional information I agree to these',
    title: 'Add a post',
  },
  defaultReviewPlaceholders: {
    ratingLabel: 'Rating*',
    reviewTitleLabel: 'Review Title*',
    reviewTitlePlaceholder: 'Ex. I would buy this product again',
    reviewLabel: 'Review*',
    reviewPlaceholder: 'Ex. I purchased this product a month ago, and I am so happy that I did!',
    nameLabel: 'Name*',
    namePlaceholder: 'Your Name',
    emailLabel: 'Email*',
    emailPlaceholder: 'Your Email',
    mediaUrlButton: '+ Add Photo or Video',
    globalErrorText: 'Check form errors',
    requiredText: '*Required Fields',
    submitButton: 'Submit Review',
    termsLinkText: 'Terms & Conditions',
    termsText: 'By submitting my review and additional information I agree to these',
    title: 'Write a Review',
  },
  genericAvatarTextColor: '#FFFFFF',
  genericAvatarBackgroundColor: '#517FA4',
  autoScrollSpeed: {
    slower: 400,
    slow: 200,
    normal: 100,
    fast: 50,
    faster: 25,
  },
  cta: {
    buttonShow: 'both',
    buttonColor: '#000000',
    textColor: '#ffffff',
  },
  hotspot: {
    color: '#ffffff',
    outlineColor: '#79b0da',
    size: '30',
  },
  popup: {
    font: 'Lato',
    fontColorBody: '#000',
    fontColorBodyDisabled: true,

    fontColorAuthor: '#000',
    fontColorAuthorDisabled: true,

    fontColorAuthorUsername: '#CCCCCC',
    fontColorAuthorUsernameDisabled: true,

    fontColorLink: '#4598BA',
    fontColorLinkDisabled: true,

    imageBackgroundColor: '#000000',
    imageBackgroundColorDisabled: true,

    backgroundColor: '#FFFFFF',
    backgroundColorDisabled: true,

    fontColorHashtagHighlight: '#4598BA',
    fontColorHashtagHighlightDisabled: true,

    lightboxColor: '#000000',
    lightboxColorDisabled: true,

    showAuthorName: true,
    showAuthorUsername: true,
    showTimestamp: true,
    size: 'normal',

    postTimeLinkColor: '#e4e4e4',
  },
  defaultQueryCount: 25,
  postTypesWithTitle: ['rss', 'youtube', 'flickr', 'review_trackers', 'google_news'],
  connectedHashtagHighlightColor: '#4598BA',
  fontColorPost: '#000000',
  fontSizeSecondary: 18,
  fontSecondary: 'Lato',
  colorNamebarButtonsBackground: '#4598BA',
  colorNamebarButtonsTextColor: '#3C3C40',
  postHighlightDuration: '15000',
  postTransitionSpeed: '15000',
  inlineVideoPlayback: 'none',
  postWidth: '300',
  postPadding: '10',
  slider: {
    themeLayout: ThemeLayoutOptions.TEXT,
  },
  defaultTintTitle: 'Social Feed',
  themes: {
    new_classic: 'new_classic',
    new_atmosphere: 'new_atmosphere',
    new_slider: 'new_slider',
    new_square_photo: 'new_square_photo',
    new_tall_photo: 'new_tall_photo',
    new_gem: 'new_gem',
    new_news: 'new_news',
    email_template_grid: 'email_template_grid',
    email_template_collage: 'email_template_collage',
    table: 'table',
  },
};
